import { useEffect, useRef } from 'react'
import { useAuth, useSignInWithLink, useAuthParams } from './index'
import { EMAIL_FOR_SIGN_IN_STORAGE_KEY } from 'config/constants'
import { ReauthenticationVariant } from 'shared/types'

export const useReauthenticationWithMail = () => {
  const { isAuthenticated } = useAuth()
  const { signInWithLink } = useSignInWithLink()
  const { security, reauthenticate } = useAuthParams()
  const reauthenticationStartedRef = useRef(false)

  useEffect(() => {
    if (!isAuthenticated || !reauthenticate || !security) {
      reauthenticationStartedRef.current = false
      return
    }

    if (reauthenticationStartedRef.current) return

    const email = window.localStorage.getItem(EMAIL_FOR_SIGN_IN_STORAGE_KEY)

    if (!email) return

    reauthenticationStartedRef.current = true

    void signInWithLink(
      email,
      window.location.href,
      true,
      ReauthenticationVariant.SECURITY
    )
  }, [isAuthenticated, reauthenticate, security, signInWithLink])
}
